import { gql } from "@apollo/client";

export const ADD_ADDRESS_ALERT = gql`
  mutation addAddressAlert($input: AddAddressAlertInput!) {
    addAddressAlert(input: $input) {
      __typename
      addressUuid
      addressAlertUuid
      addressAlert {
        alertType {
          __typename
          id
          name
          alertLevel
          position
          oriId
        }
        expireAt
        id
        notes
        officer {
          id
        }
      }
      clientMutationId
      errors
    }
  }
`;

//Example input:
// {
//   "input": {
//     "addressId": 1,
//     "officerId": 1,
//     "alertTypeId": 1,
//     "notes": 1,
//     "expireAt": 1,
//     "clientMutationId": 1
//   }
// }
